export default __webpack_public_path__ + "static/media/logo_horizontal_healthgenom.09f808eb.svg";